import axios from 'axios';
import { Token } from '../interfaces/api/token';

export async function getToken(username: string, password: string): Promise<Token> {
	try {
		const response = await axios.post<Token>('token-auth/', {
			username: username,
			password: password,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
